import React, { useRef, useEffect } from "react";
import dynamic from 'next/dynamic';
import Head from 'next/head'
import Image from 'next/image'
import { Inter } from 'next/font/google'
import styles from '../../styles/Home.module.css'

import Navbar from '../../../components/navbar';
import Footer from '../../../components/footer';
import  Layout from '../../../components/layout';

const FaceMeshComponent = dynamic(() => import('../../../components/facemesh'), {
    ssr: false
  });
  
export async function getServerSideProps({ query }) {
  
  let faceShape = null;
  let eyeShapeTemp = ["Almond"];
  let eyeSettingTemp = ["Proportionally Set Eyes"];
  if (query.faceShape) {
    faceShape = Array.isArray(query.faceShape) ? query.faceShape : [query.faceShape];
  }
  if (query.eyeShape) {
    eyeShapeTemp = Array.isArray(query.eyeShape) ? [query.eyeShape[0]] : [query.eyeShape];
  }  
  if (query.eyeSetting) {
    eyeSettingTemp = Array.isArray(query.eyeSetting) ? [query.eyeSetting[0]] : [query.eyeSetting];
  }
  return {
    props: {
      // page: query.page || null,
      faceShape: faceShape,
      eyeShape: eyeShapeTemp,
      eyeSetting: eyeSettingTemp
    },
  };
}

export default function HomePage({ faceShape, eyeShape, eyeSetting }) {
  // 
return (
  <>
    <Head>
      <title>Best Eyeliner for your Eye Shape | Personalized Makeup Filters with AI</title>
      <meta
        name="description"
        content="Use our eyeliner guide tailored to your eye shape to learn how to best accentuate your facial features. It's as easy as a TikTok or Snapchat filter — we use AR to overlay makeup guides on your face in real-time, and AI to identify your eye shape."
        key="desc"
      />
    </Head>        
    {/* <main className={styles.main}>
    <Navbar />
    <FaceMeshComponent page={"makeup_recommendations/eyeliner"} faceShape={ faceShape } eyeShape={ eyeShape } eyeSetting={ eyeSetting }/>     
    <Footer />
    </main> */}
    <Layout page={"makeup_recommendations/eyeliner"} selectedOption={"makeup_recommendations/eyeliner"} faceShape={ faceShape } eyeShape={ eyeShape } eyeSetting={ eyeSetting }/>
  </>
  )
}

// export default HomePage;